
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartContourLabelIec as ObiChartContourLabelIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-contour-label-iec.js';
 
 
 

 
 export const ObiChartContourLabelIec = createComponent({
   react: React,
   tagName: 'obi-chart-contour-label-iec',
   elementClass: ObiChartContourLabelIecElement,
   events: {
     
   }
  });
 
 